import { useState, useEffect, useCallback } from "react";
import { ReportService } from "../service/reportApi";

const getTodayIST = () => {
  const d = new Date();
  return d.toISOString().split("T")[0];
};

export const useReportData = (currentUser) => {
  const [filters, setFilters] = useState({
    startDate: getTodayIST(),
    endDate: getTodayIST(),
    service: "",
    page: 1,
    pageSize: 50,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reportData, setReportData] = useState({
    role: "",
    grandTotals: null,
    serviceTotals: [],
    dayWiseSummary: [],
    transactions: [],
    pagination: { page: 1, total_pages: 1, total_rows: 0 },
  });

  const fetchData = useCallback(async () => {
    if (!currentUser?.id) return;
    setLoading(true);
    setError(null);
    try {
      const res = await ReportService.getDayWiseReport({
        userId: currentUser.id,
        startDate: filters.startDate,
        endDate: filters.endDate,
        service: filters.service,
        page: filters.page,
        pageSize: filters.pageSize,
      });

      if (res.status === false) {
        throw new Error(res.error || "Failed to load report data");
      }

      setReportData({
        role: res.role,
        grandTotals: res.grand_totals || {},
        serviceTotals: res.service_totals || [],
        dayWiseSummary: res.day_wise_summary || [],
        transactions: res.data || [],
        pagination: res.pagination || { page: 1, total_pages: 1, total_rows: 0 },
      });
    } catch (err) {
      setError(err.response?.data?.error || err.message || "An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  }, [currentUser?.id, filters]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const updateFilters = (newFilters) => {
    setFilters((prev) => ({
      ...prev,
      ...newFilters,
      page: newFilters.page !== undefined ? newFilters.page : 1, // reset page on filter change
    }));
  };

  return {
    filters,
    updateFilters,
    loading,
    error,
    reportData,
    refetch: fetchData,
  };
};
